






































































import { Vue, Component } from 'vue-property-decorator';
import { fetchUserState, fetchAds } from '../api';
import { Toast } from 'vant';
import moment from 'moment';
import openAppTip from '@/plugins/WxOpenAppTip';
import User from '../components/User.vue';
// 根据环境跳转地址
const ENV_NAME_URL: { [key: string]: any } = {
  development: (url: string) =>
    ` http://172.16.18.130:8081/composition/usercenter?isContinuous=false&sourceSite=${url}`,
  TEST: (url: string) =>
    `https://testwap.cqcb.com/shangyou_news/composition/usercenter?isContinuous=false&sourceSite=${url}`,
  production: (url: string) =>
    `https://wap.cqcb.com/shangyou_news/composition/usercenter?isContinuous=false&sourceSite=${url}`,
};
Vue.use(Toast).use(openAppTip);
@Component({
  components: {
    User,
  },
})
export default class Save extends Vue {
  userStateData: any = {};
  ads = [];
  grade = [
    {
      text: '一年级',
      value: 1,
    },
    {
      text: '二年级',
      value: 2,
    },
    {
      text: '三年级',
      value: 3,
    },
    {
      text: '四年级',
      value: 4,
    },
    {
      text: '五年级',
      value: 5,
    },
    {
      text: '六年级',
      value: 6,
    },
    {
      text: '初一',
      value: 7,
    },
    {
      text: '初二',
      value: 8,
    },
    {
      text: '初三',
      value: 9,
    },
    {
      text: '高一',
      value: 10,
    },
    {
      text: '高二',
      value: 11,
    },
    {
      text: '高三',
      value: 12,
    },
    {
      text: '专科',
      value: 16,
    },
    {
      text: '本科',
      value: 17,
    },
    {
      text: '硕士研究生',
      value: 18,
    },
    {
      text: '博士研究生',
      value: 19,
    },
  ];
  async created() {
    this.getUserInfo();
    this.getAds();
  }
  get inApp() {
    return !!window.udid;
  }
  get userInfo() {
    return (
      this.userStateData &&
      this.userStateData.data &&
      this.userStateData.data.userInfo
    );
  }
  get statusCode() {
    return this.userStateData && this.userStateData.statusCode;
  }
  get userState() {
    // 201 未注册； 202 审核中； 203 审核通过； 204 淘汰
    if (+this.statusCode === 201 && !this.userInfo) {
      return 201;
    } else if (+this.statusCode === 203) {
      return 203;
    } else if (+this.statusCode === 202) {
      return 202;
    } else if (+this.statusCode === 201 && this.userInfo) {
      return 204;
    } else {
      return 201;
    }
  }
  gradeText(val: string) {
    return this.grade.find((item) => item.value === +val);
  }
  onNavToRegister() {
    // 结束时间
    const END_TIME = '2024/01/30 24:00';
    if (moment(END_TIME) < moment()) {
      Toast('活动报名时间已截至！');
      return;
    }
    const check = this._beforeJumpToRegisterCheck();
    if (!check) {
      return;
    }
    location.href = ENV_NAME_URL[process.env.VUE_APP_ENV_NAME as string](
      location.href,
    );
  }
  async getUserInfo() {
    const res = await fetchUserState();
    this.userStateData = res;
  }
  _beforeJumpToRegisterCheck() {
    // 没在app提示下载打开
    if (!this.inApp) {
      this.$openAppTip();
      return false;
    }
    // 在app没登录的时候提示登录
    const userLogin = window.gettoken() && window.gettoken() !== 'null';
    if (window.udid && !userLogin) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
      return false;
    }
    return true;
  }
  async getAds() {
    const ret = await fetchAds(4);
    this.ads = ret.data;
  }
  jumpToAdPage(url: string) {
    location.href = url;
  }
}
